import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const HeroImage = () => {
  const data = useStaticQuery(graphql`
{
  allFile(filter: {relativeDirectory: {eq: "footer"}, name: {eq: "iso-27001"}}) {
    edges {
      node {
        childImageSharp {
          fixed(height: 60, cropFocus: CENTER) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  }
}


  `)
  return <Image fixed={data.allFile.edges[0] && data.allFile.edges[0].node.childImageSharp.fixed} alt="iso-27001 logo"/>
}

export default HeroImage
